import Vue from "vue";
import Router from "vue-router";
import RoeMainLayout from "@/components/layouts/MainLayout";
import store from "@/store";
import {AUTH_LOGGEDIN} from "@/store/mutations.type";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: RoeMainLayout,
      children: [
        // {
        //   path: "/",
        //   name: "report-list",
        //   component: () => import("@/views/ReportList")
        // },
        {
          path: "/social_security_calc",
          name: "social_security_calc",
          component: () => import("@/views/calculators/SocialSecurity")
        },
        {
          path: "/other_calc",
          name: "other_calc",
          component: () => import("@/views/calculators/Other")
        },
        {
          path: "/dc_contribution_calc",
          name: "dc_contribution_calc",
          component: () => import("@/views/calculators/DcContribution")
        },
        {
          path: "/dc_balances_calc",
          name: "dc_balances_calc",
          component: () => import("@/views/calculators/DcBalance")
        },
        {
          path: "/social_security_taxable_calc",
          name: "social_security_taxable_calc",
          component: () => import("@/views/calculators/SocialSecurityTaxable")
        },
        {
          path: "/state_retirement_taxes_calc",
          name: "state_retirement_taxes_calc",
          component: () => import("@/views/calculators/StateRetirementTaxes")
        },
        {
          path: "/state_tax_calc",
          name: "state_tax_calc",
          component: () => import("@/views/calculators/StateTax")
        },
        {
          path: "/input_fields",
          name: "input_fields",
          component: () => import("@/views/calculators/InputFields")
        },
        {
          path: "/output_fields_calc",
          name: "output_fields_calc",
          component: () => import("@/views/calculators/OutputFields")
        },
        {
          path: "/annual_costs",
          name: "annual_costs",
          component: () => import("@/views/calculators/AnnualCost")
        },
        {
          path: "/sso-login",
          name: "sso-login",
          component: () => import("@/views/TempSsoLogin")
        },
        {
          path: "/contribution_calc",
          name: "contribution_calc",
          component: () => import("@/views/calculators/Contribution")
        }
      ]
    },
    {
      path: "/",
      component: () => import("@/components/layouts/ReportLayout"),
      children: [
        {
          path: "/reports/:id/introduction",
          name: "report-introduction",
          component: () => import("@/views/ReportIntroduction")
        },
        {
          path: "/reports/:id/participants-:step",
          name: "report-participants",
          component: () => import("@/views/ReportParticipants")
        },
        {
          path: "/reports/:id/edit-:step",
          name: "report-edit",
          component: () => import("@/views/ReportEdit")
        },
        {
          path: "/reports/:id/alternative-designs",
          name: "report-alternative-designs",
          component: () => import("@/views/AlternativeDesigns")
        },
        {
          path: "/reports/:id/download",
          name: "report-download",
          component: () => import("@/views/ReportDownload")
        }
      ]
    },
    {
      path: "/not-authorized",
      name: "not-authorized",
      component: () => import("@/components/auth/NotAuthorized"),
      meta: {
        noAuth: true
      }
    }
    // TODO: not used
    // {
    //   path: "/register",
    //   name: "register",
    //   component: () => import("@/components/auth/Register"),
    //   meta: {
    //     noAuth: true
    //   }
    // },
    // {
    //   path: "/login",
    //   name: "login",
    //   component: () => import("@/components/auth/Login"),
    //   meta: {
    //     noAuth: true
    //   }
    // }
  ]
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => !record.meta.noAuth)) {
    if(to.query.token) {
      store.commit(AUTH_LOGGEDIN, to.query.token);
      next(to.path); // next();
      return;
    }
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next("/not-authorized");
  } else {
    next();
  }
});

export default router;
